export default function PageHero({ eyebrow, title, description, image }) {
  return (
    <section
      data-testid="page-hero"
      className="relative min-h-[56vh] md:min-h-[64vh] flex items-end overflow-hidden"
    >
      <img
        src={image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/85 via-brand-ink/55 to-brand-ink/25" />
      <div className="relative container-x py-20 md:py-28 w-full">
        <div className="max-w-3xl animate-fade-up">
          {eyebrow && (
            <p className="eyebrow !text-brand-gold mb-5">{eyebrow}</p>
          )}
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white leading-[1.05]">
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
